import axios from "axios";
import React from "react";
import GetServerAddress from "../../../../../functions/GetServerAddress";

export function Request_Letter(
  Attendee,
  Letter,
  Emails,
  BCCEmails,
  newNote,
  logout
) {
  // Choose fields like this:
  // { item: 1, status: 1, _id: 0 }

  const fetchData = async () => {
    try {
      const response = await axios.post(
        GetServerAddress() + "api/staff/Request_Letter",
        {
          Attendee: Attendee,
          Letter: Letter,
          Emails: Emails,
          BCCEmails: BCCEmails,
          newNote: newNote,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
            username: localStorage.getItem("Username"),
            activitylog: "Yes",
            aboutid: Attendee._id,
          },
        }
      );
      // Check for specific server response indicating an invalid auth token
      if (response.data.status === 403 || response.data.status === 401) {
        logout();

        return; // Stop further execution in case of invalid auth token
      }
      console.log("Response Data: ", response);
    } catch (error) {
      console.error("Error fetching data: ", error);
      window.alert(
        "Error Getting data, please speak to Admin if this issue persists: ",
        error
      );
    }
  };
  fetchData();
} // Empty dependency array means this effect runs only once
